
import './App.scss';
// Components
import Navbar from './components/Nabvar.js';
import About from './components/About.js'
import Contact from './components/Contact.js';
// Dependencies
import { Routes, Route, Link } from 'react-router-dom';
import PortapholioCard from './components/portapholio/PortapholioCard.js';




function App() {

  return (<>
    <Navbar />
    <div className="App">
        <Routes>
        <Route path="/" element={<PortapholioCard />} />
        <Route path="/Home" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/menu" element={""} />
      </Routes>
    </div>
    
    </>
  );
}

export default App;
